import { SiteActivityComponent } from '@cms-max/cms-browser-api-client'
import { Divider } from 'components/Divider/Divider'
import { ContentLayout } from 'components/Layouts'

type SplitPageProps = {
  heading: string
  nav?: React.ReactNode
  left: React.ReactNode
  right: React.ReactNode
  bottom?: React.ReactNode
  printComponent: SiteActivityComponent
}
export function SplitPageLayout ({
  heading,
  nav,
  left,
  right,
  bottom,
  printComponent
}: SplitPageProps) {
  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={heading}
      nav={nav}
      width="wide"
      withPrintButton
      printComponent={printComponent}
    >
      <div className="ds-l-container">
        <div className="ds-u-display--flex ds-u-flex-direction--column ds-u-lg-flex-direction--row my-u-gap--12">
          <div className="my-u-lg-basis--5/12 my-u-flex-grow-1">{left}</div>

          <Divider
            orientation="vertical"
            className="ds-u-display--none ds-u-lg-display--block"
          />

          <div className="my-u-lg-basis--7/12 my-u-flex-grow-1">{right}</div>
        </div>

        {bottom && (
          <>
            <Divider className="ds-u-margin-top--7 ds-u-margin-bottom--3" />
            {bottom}
          </>
        )}
      </div>
    </ContentLayout>
  )
}
